<template>
  <b-badge
    v-b-tooltip:hover
    variant="warning"
    :title="title"
    data-cy="premium-feature"
  >
    Premium Feature
  </b-badge>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  tooltipText: {
    type: String,
    default: '',
  },
}

@Component
export default class PremiumFeature extends Vue.extend({ props }) {
  get title () {
    const start = 'Access to this feature is not included in your OrbViz plan'
    const end = this.tooltipText ? `. ${this.tooltipText}` : ''
    return start + end
  }
}

</script>
